{
    "navbar": {
        "help_center": "Centro d'aiuto",
        "share_idea": "Condividere un'idea",
        "logout": "Esci"
    },
    "languages": {
        "title": "Lingua",
        "explanation": "È possibile sostituire la lingua dell'interfaccia con una delle lingue qui sotto",
        "de": "Tedesco",
        "fr": "Francese",
        "en": "Inglese",
        "it": "Italiano",
        "es": "Spagnolo"
    },
    "form": {
        "submit": "Confermare",
        "cancel": "Annullare",
        "errors": {
            "required": "Campo obbligatorio"
        }
    },
    "menu": {
        "request_manager": {
            "title": "Request Manager",
            "pipeline": "Pipeline",
            "todo": "To Do",
            "inbox": "Inbox",
            "message_templates": "Message Templates"
        },
        "offer_manager": {
            "title": "Offer Manager",
            "itineraries": "Itinerari Online"
        },
        "cash_manager": {
            "title": "Cash Manager",
            "accounting": "Contabilità"
        },
        "insights": {
            "title": "Insights",
            "statistics": "Statistiche",
            "customer_satisfaction": "Soddisfazione del Cliente",
            "better_trip_index": "Better Trip Index"
        },
        "tipi": {
            "title": "Trip Planner",
            "library": "Biblioteca"
        },
        "tools": {
            "title": "Resources Center",
            "partner_connect": "Partner Connect"
        },
        "agency_manager": {
            "title": "Agency Manager",
            "main_contacts": "Contatti Principali",
            "active_accounts": "Conti Attivi",
            "agency_capacity": "Capacità dell'agenzia",
            "legal_information": "Informazioni legali"
        }
    }
}
